import {createBrowserRouter, Navigate} from "react-router-dom";
import Actual from "../pages/list/Actual";
import Archived from "../pages/list/Archived";
import Description from "../pages/edit/Description";
import EditLayout from "../pages/edit/EditLayout";
import Criterions from "../pages/edit/Criterions";
import Dataset from "../pages/edit/Dataset";
import Documents from "../pages/edit/Documents";
import ManagerTasks from "../pages/edit/ManagerTasks";
import Planner from "../pages/edit/Planner";
import Factors from "../pages/edit/Factors";
import Admin from "../pages/admin";
import Diagram from "../pages/gant";
import Reports from "../pages/reports";

const router = createBrowserRouter([
  {
    children: [
      {
        path: "/",
        element: <Navigate replace to="/briefs/actual"/>,
      },
      {
        path: "/briefs",
        children: [
          {
            index: true,
            element: <Navigate to="actual" replace />,
          },
          {
            path: "actual",
            element: <Actual/>,
          },
          {
            path: "archived",
            element: <Archived/>,
          },
          {
            path: "/briefs/:id",
            element: <EditLayout/>,
            children: [
              {
                path: "description",
                element: <Description/>,
              },
              {
                path: "criterions",
                element: <Criterions/>,
              },
              {
                path: "manager-tasks",
                element: <ManagerTasks/>,
              },
              {
                path: "dataset",
                element: <Dataset/>,
              },
              {
                path: "documents",
                element: <Documents/>,
              },
              {
                path: "factors",
                element: <Factors/>,
              },
            ],
          },
          {
            path: "/briefs/:id/planner/:period",
            element: <Planner/>,
          },
        ],
      },
      {
        path: "/report",
        element: <Reports/>,
      },
    ],
  },
  {
    path: "/admin/",
    element: <Admin/>,
  },
  {
    path: "/diagram/",
    element: <Diagram/>,
  },
])

export default router
